"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _i18n = require("@wordpress/i18n");

var _icons = require("@wordpress/icons");

/**
 * WordPress dependencies
 */
const variations = [{
  name: 'group',
  title: (0, _i18n.__)('Group'),
  description: (0, _i18n.__)('Gather blocks in a layout container.'),
  attributes: {
    layout: {
      type: 'default'
    }
  },
  scope: ['transform'],
  isActive: blockAttributes => {
    var _blockAttributes$layo, _blockAttributes$layo2;

    return !blockAttributes.layout || !((_blockAttributes$layo = blockAttributes.layout) !== null && _blockAttributes$layo !== void 0 && _blockAttributes$layo.type) || ((_blockAttributes$layo2 = blockAttributes.layout) === null || _blockAttributes$layo2 === void 0 ? void 0 : _blockAttributes$layo2.type) === 'default';
  },
  icon: _icons.group
}, {
  name: 'group-row',
  title: (0, _i18n.__)('Row'),
  description: (0, _i18n.__)('Arrange blocks horizontally.'),
  attributes: {
    layout: {
      type: 'flex',
      flexWrap: 'nowrap'
    }
  },
  scope: ['inserter', 'transform'],
  isActive: blockAttributes => {
    var _blockAttributes$layo3, _blockAttributes$layo4, _blockAttributes$layo5;

    return ((_blockAttributes$layo3 = blockAttributes.layout) === null || _blockAttributes$layo3 === void 0 ? void 0 : _blockAttributes$layo3.type) === 'flex' && (!((_blockAttributes$layo4 = blockAttributes.layout) !== null && _blockAttributes$layo4 !== void 0 && _blockAttributes$layo4.orientation) || ((_blockAttributes$layo5 = blockAttributes.layout) === null || _blockAttributes$layo5 === void 0 ? void 0 : _blockAttributes$layo5.orientation) === 'horizontal');
  },
  icon: _icons.row
}, {
  name: 'group-stack',
  title: (0, _i18n.__)('Stack'),
  description: (0, _i18n.__)('Arrange blocks vertically.'),
  attributes: {
    layout: {
      type: 'flex',
      orientation: 'vertical'
    }
  },
  scope: ['inserter', 'transform'],
  isActive: blockAttributes => {
    var _blockAttributes$layo6, _blockAttributes$layo7;

    return ((_blockAttributes$layo6 = blockAttributes.layout) === null || _blockAttributes$layo6 === void 0 ? void 0 : _blockAttributes$layo6.type) === 'flex' && ((_blockAttributes$layo7 = blockAttributes.layout) === null || _blockAttributes$layo7 === void 0 ? void 0 : _blockAttributes$layo7.orientation) === 'vertical';
  },
  icon: _icons.stack
}];
var _default = variations;
exports.default = _default;
//# sourceMappingURL=variations.js.map